import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  okay: () => __(translations.mergeDirectoryForm.okay, 'Okay'),
  mergeWith: () => __(translations.mergeDirectoryForm.mergeWith, 'Merge with'),
  title: () => __(translations.mergeDirectoryForm.alertTitle, 'Merge directory'),
  mergeMessage: () => __(translations.mergeDirectoryForm.mergeMessage, '{{source}} will be merged with {{destination}} and will be archived.'),
};
